module.exports = __webpack_public_path__ + "img/t4.86a74662.jpg";